module.exports = __webpack_public_path__ + "static/media/certificate-enrolled-0-4.aa34a970.svg";